module.exports = __webpack_public_path__ + "assets/images/joinmember02-1B-FvP2.jpg";